import React, { PropsWithChildren } from 'react';
import { BrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { HydrationBoundary } from '@tanstack/react-query';

import SnackBarProvider from '../../main/pages/components/SnackBarProvider';

interface Props {
    queryState: object;
}

const ClientProviders: React.FC<PropsWithChildren<Props>> = ({ children, queryState }) => {
    return (
        <HydrationBoundary state={queryState}>
            <SnackBarProvider>
                <BrowserRouter>
                    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>{children}</Sentry.ErrorBoundary>
                </BrowserRouter>
            </SnackBarProvider>
        </HydrationBoundary>
    );
};

export default ClientProviders;
